import { LoginCallback, SecureRoute } from '@okta/okta-react';
import { Loader } from 'cdk-radial';
import { Route, Redirect } from 'react-router-dom';
import { useClient } from 'components/ClientProvider';
import { ErrorMessage } from 'components/ErrorMessageHandler/ErrorMessage';
import { SuccessMessage } from 'components/SuccessMessage/SuccessMessage';
import { useURLs } from 'hooks';
import { ApSchedulePage } from 'pages/ApSchedulePage';
import { LandingPage } from 'pages/LandingPage';

const OktaSecureWrapper = (): React.JSX.Element => {
  const client = useClient();
  const urls = useURLs();
  return (
    <>
      {client === null && <Loader label="" />}
      <div id="App" data-testid="wrapped-component">
        <SecureRoute
          exact
          path="/"
          render={() => <Redirect to={urls.apSchedule} />}
        />
        <SecureRoute
          exact
          path={urls.apSchedule}
          render={() => <ApSchedulePage />}
        />
        <SecureRoute
          exact
          path={urls.landingPage}
          render={() => <LandingPage />}
        />
        <Route path="/" component={LoginCallback} />
        <ErrorMessage />
        <SuccessMessage />
      </div>
    </>
  );
};

export default OktaSecureWrapper;
